import { render, staticRenderFns } from "./ExtractedInformation.vue?vue&type=template&id=1506d7ee&scoped=true&"
import script from "./ExtractedInformation.vue?vue&type=script&lang=js&"
export * from "./ExtractedInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1506d7ee",
  null
  
)

export default component.exports